<template>
  <main id="shipper-cutoff-group">
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('shipperCutoffGroup.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter" />
        </el-col>
      </el-row>
      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="12" class="default-section-title">
              {{ $t('shipperCutoffGroup.summary') }}
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
            <div class="default-section-actions text-align-end">
              <add-cutoff-group />
            </div>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>

<script>
import SearchFilter from './SearchFilter';
import SearchSummary from './SearchSummary';
import AddCutoffGroup from './components/AddCutoffGroup';

export default {
  name: 'ShipperCutoffGroup',
  components: {
    AddCutoffGroup,
    SearchFilter,
    SearchSummary,
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    }
  }
};
</script>
